import {API_URL, THEME_COLOR, numberWithCommas, CMS_URL} from "../constant"
import React, {useEffect, useState} from 'react';
import HeaderBack from "../layout/HeaderBack";
import "./Cart.css";
import $ from 'jquery';
import { useLocalStorage } from "../useLocalStorage";
import M from "materialize-css";
import toast, { Toaster } from 'react-hot-toast';
import SlidingPane from 'react-sliding-pane';
import "react-sliding-pane/dist/react-sliding-pane.css";
import Warehouse from "./component/Warehouse";
import Expedition from "./component/Expedition";
import Coupon from "./component/Coupon";
import Bank from "./component/Bank";
import Reward from "./component/Reward";

import banner1 from "../logo.svg"


import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { useHistory } from "react-router";

import jwt from "jsonwebtoken"
import Swal from "sweetalert2";
import FAO from "./component/FAO";

const Checkout = (props)=>{

    const [token, setToken] = useLocalStorage("token", "");
    const [memberStatus, setMemberStatus] = useState("");
    const [sumorder, setSumOrder] = useState(0);
    const [sumitem, setSumItem] = useState(0);
    const [sumshipping, setSumShipping] = useState(0);
    const [sumtotal, setSumTotal] = useState(0);
    const [sumdiscounttransaction, setDiscountTransaction] = useState(0);
    const [sumdiscountshippingfee, setDiscountShippingFee] = useState(0);
    const [sumdiscountmember, setSumDiscountMember] = useState(0);
    const [minimumOrder, setMinimumOrder] = useState(0);
    const [items, setItems] = useState([]);
    const [discountMember, setDiscountMember] = useState(0);
    const [discounts, setDiscounts] = useState([]);
    const [isPromo, setIsPromo] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenBank, setIsOpenBank] = useState(false);
    const [isOpenReward, setIsOpenReward] = useState(false);
    const [isOpenCoupon, setIsOpenCoupon] = useState(false);
    const [isOpenFAO, setIsOpenFAO] = useState(false);
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [selectedWHCityID, setSelectedWHCityID] = useState(-1);
    const [selectedShippingCityID, setSelectedShippingCityID] = useState(-1);
    const [paymentMethod, setPaymentMethod] = useState({
        Code: "",
        Name: ""
    });
    const [note, setNote] = useState("");
    const [rewards, setRewards] = useState([]);
    const [coupons, setCoupons] = useState([]);
    const [rewardAmount, setRewardAmount] = useState(0);
    const [fao, setfao] = useState({});
    const [totalWeight, setTotalWeight] = useState(0);

    let prevwh = 0;
    let prevshipmethod = "";
    let prevshipdetail = 0;
    let history = useHistory();

    let Cardcontainer = (props) => {

        function ClickExpedition(index,WHCityID, ShippingCityID){
            if(props.onClick){
                props.onClick(index,WHCityID, ShippingCityID, props.items)
            }
        }

        let ExpeditionName = () => <span style={{color:"red"}}>Select Expedition</span>;

        useEffect(()=>{
            var elems = document.querySelectorAll('.collapsible');
            var instances = M.Collapsible.init(elems);
        },[])

        return (
            <div className="cart-card" key={`wh-${props.uniquekey}`}>
                <div className="cart-card-container">
                    <div className="cart-item-header">
                        <div className="cart-warehouse-name">
                            {props.warehousename}
                        </div>
                        <div className="cart-shipping-method">
                            {props.shippingmethod}
                        </div>
                    </div>
                    <hr />
                    {
                        props.items.map((value, index)=>{
                            let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                            if(value.ImageName){
                                imgurl = `${CMS_URL}/images/upload/product/${value.ItemCode}/${value.ImageName}`;
                            }
                            return (
                                <div className="cart-item-detail" key={`${value.WarehouseDetail.WarehouseID}-${index}`}>
                                    {/* <div className="cart-item-checkbox">
                                        <label>
                                            <input type="checkbox" />
                                            <span></span>
                                        </label>
                                    </div> */}
                                    <div className="cart-item-image">
                                        <img src={imgurl}/>
                                    </div>
                                    <div className="cart-item-summary">
                                        <div className="cart-item-name">
                                            <span>{value.ItemName}</span>
                                        </div>
                                        <div className="cart-item-price">
                                            Rp {numberWithCommas(value.ItemPrice)}
                                        </div>
                                        <div className="cart-item-name">
                                            {`${value.ItemQty} ${value.ItemUoM} (${value.ItemQty * value.ItemWeight} Kg)`}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div>
                <ul className="collapsible" style={{marginBottom:0}}>
                    <li>
                        <div className="collapsible-header"><i className="material-icons">location_on</i>{(props.shippingmethod == "PICKUP") ? "Pick Up" : "Shipping"} Address</div>
                        <div className="collapsible-body"><span>{
                            (props.shippingmethod == "PICKUP") ?
                            `${props.items[0].WarehouseDetail.WarehouseAddress},${props.items[0].WarehouseDetail.WarehouseSubDistrict}${props.items[0].WarehouseDetail.WarehouseCity},${props.items[0].WarehouseDetail.WarehouseProvince},${props.items[0].WarehouseDetail.WarehouseNation}` :
                            `${props.items[0].ShippingDetail.ShippingDetailAddress},${props.items[0].ShippingDetail.ShippingDetailSubDistrict},${props.items[0].ShippingDetail.ShippingDetailCity},${props.items[0].ShippingDetail.ShippingDetailProvince},${props.items[0].ShippingDetail.ShippingDetailNation}`
                        }</span></div>
                    </li>
                </ul>
                </div>
                {
                    (props.shippingmethod != "PICKUP")?
                    (
                        (props.items[0].ExpeditionDetail.ExpeditionCode == "") ?
                        (
                            <div className="cart-expedition-container" onClick={()=>ClickExpedition(props.uniquekey, props.items[0].WarehouseDetail.WarehouseCityID, props.items[0].ShippingDetail.ShippingDetailCityOngkirID)}>
                                <div className="cart-expedition-name">
                                    <ExpeditionName/>
                                </div>
                                <div className="cart-expedition-icon">
                                <i className="material-icons">chevron_right</i>
                                </div>
                            </div>
                        ):
                        (
                            <div className="cart-expedition-container" onClick={()=>ClickExpedition(props.uniquekey, props.items[0].WarehouseDetail.WarehouseCityID, props.items[0].ShippingDetail.ShippingDetailCityOngkirID)}>
                                <div className="cart-expedition-name">
                                    {props.items[0].ExpeditionDetail.ExpeditionName}
                                </div>
                                <div className="cart-expedition-price">
                                    Rp. {numberWithCommas(props.items[0].ExpeditionDetail.ExpeditionFee)}
                                </div>
                            </div>
                        )

                    ):
                    ("")
                }
            </div>
        );
    }

    function requestCheckout(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("items", JSON.stringify(items));
        urlencoded.append("paymentmethod", JSON.stringify(paymentMethod));
        urlencoded.append("note", note);
        urlencoded.append("total", sumtotal);
        urlencoded.append("totalitem", sumitem);
        urlencoded.append("totalreward", rewardAmount);
        urlencoded.append("discountmember", discountMember);
        urlencoded.append("memberdiscount", sumdiscountmember);
        urlencoded.append("shippingfee", sumshipping);
        urlencoded.append("shippingfeediscount", sumdiscountshippingfee);
        urlencoded.append("promodiscount", sumdiscounttransaction);
        urlencoded.append("rewards", JSON.stringify(rewards));
        urlencoded.append("coupons", JSON.stringify(coupons));


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/checkout`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    function getNewToken(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/token`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    function validationExpedition(){
        let valid = true;
        let prevwh = -1;
        items.map((value, index)=>{
            if(prevwh != value.WarehouseDetail.WarehouseID){
                prevwh = value.WarehouseDetail.WarehouseID;
                if(value.ShippingMethod == "SHIP BY" && value.ExpeditionDetail.ExpeditionCode == "")
                    valid = false;
            }
        })
        return valid;
    }

    function validationPayment(){
        let valid = true;
        if(paymentMethod.Code == ""){
            valid = false;
        } 
        return valid;
    }

    function validationFAO(){
        let valid = true;
        if(memberStatus == "Join" && (minimumOrder - sumitem) <= 0 && !fao.Name){
            valid = false;
        } 
        return valid;
    }

    async function submitHandler(){
        setIsOpenBackdrop(true);
        if(items.length == 0){
            toast.error('No item Selected');
        }
        else if(!validationExpedition()){
            toast.error('Select Expedition');
        }
        else if(!validationPayment()){
            toast.error('Select Payment Method');
        }
        else if(!validationFAO()){
            toast.error('Select 1 FAO');
        }
        else{
            let response = await requestCheckout();
            response = JSON.parse(response);
            if(response.status == 200){
                let restoken = await getNewToken();
                if(restoken.status == 200){
                    setToken(restoken.token)
                    window.history.replaceState(null, null, `/paymentinfo/${response.idpayment}`);
                    toast.success("sukses");
                    window.location.reload();
                }else{
                    toast.error(response.message)
                }
            }else{
                toast.error(response.message)
                // console.log(response.message)
            }
        }
        setIsOpenBackdrop(false);
    }

    function deleteItem(ID){
        let titems = items.filter((value,index)=> value.ID != ID);
        console.log('itu-->', titems.length);
        setItems(titems)
        console.log('ini-->', items.length);
        recalculate();

    }

    async function decrementQty(ID){
        let index = 0;
        let titems = items;
        // let item = items[index];
        let item = items.filter((value,idx)=> {
            if(value.ID == ID)
                index = idx;
            return value.ID == ID
        })[0];
        item.ItemQty -= 1;
        if(item.ItemQty < 1){
            item.ItemQty = 1;
        }
        titems[index] = item;
        setItems(titems);
        recalculate();
    }

    function incrementQty(ID){
        let index = 0;
        let titems = items;
        // let item = items[index];
        let item = items.filter((value,idx)=> {
            if(value.ID == ID)
                index = idx;
            return value.ID == ID
        })[0];
        item.ItemQty++;
        titems[index] = item;
        setItems(titems);
        recalculate();
        
    }


    function qtyKeyPress(event){
        if(! (event.charCode >= 46 && event.charCode <= 57)){
            event.preventDefault();
        }
    }
    
    function qtyChange(e){
        let index = 0;
        let titems = items;
        // let item = items[index];
        let item = items.filter((value,idx)=> {
            if(value.ID == e.target.dataset.itemid)
                index = idx;
            return value.ID == e.target.dataset.itemid
        })[0];
        item.ItemQty = (!e.target.value || e.target.value=="" || e.target.value == isNaN)? 1: parseInt(e.target.value)
        if(item.ItemQty < 1){
            item.ItemQty = 1;
        }
        titems[index] = item;
        setItems(titems);
        recalculate();
    }

    function recalculate(){
        let sum = 0;
        let sumi = 0;
        let sums = 0;
        let sumt = 0;
        let sumdt = 0;
        let sumds = 0;
        items.map((value, index)=>{
            sum += (value.ItemQty * value.ItemPrice);
            sumi += (value.ItemQty * value.ItemPrice);
            if(value.ShippingMethod == "SHIP BY"){
                sum += parseInt(value.ExpeditionDetail.ExpeditionFee)
                sums += parseInt(value.ExpeditionDetail.ExpeditionFee)
            }
        })
        for (let index = 0; index < coupons.length; index++) {
            const element = coupons[index];
            let diskon = 0;
            if(element.Type == 0){
                diskon = sums * element.ValuePercent/100
                if(diskon > element.MaximumDiscount) diskon = element.MaximumDiscount
                sumds += diskon
            }
            else if(element.Type == 1){
                diskon = element.ValueAmount
                if(diskon > element.MaximumDiscount) diskon = element.MaximumDiscount
                sumds += diskon
            }
            else if(element.Type == 2){
                diskon = sumi * element.ValuePercent/100
                if(diskon > element.MaximumDiscount) diskon = element.MaximumDiscount
                sumdt += diskon
            }
            else if(element.Type == 3){
                diskon = element.ValueAmount
                if(diskon > element.MaximumDiscount) diskon = element.MaximumDiscount
                sumdt += diskon
            }
            
        }
        let itemdiscounted = sumi * (100-discountMember)/100;
        let diskonmember = sumi * discountMember / 100;
        let totaltransaction = itemdiscounted - sumdt;
        let totalshipment = sums - sumds;
        if(totaltransaction < 0) totaltransaction = 0;
        if(totalshipment < 0) totalshipment = 0;
        if(rewardAmount > 0){
            totaltransaction = sumi;
            totalshipment = sums;
            itemdiscounted = sumi;
            diskonmember = 0;
        }
        sumt = (totaltransaction) + (totalshipment) - rewardAmount
        if(sumt < 0 ) sumt = 0
        setSumOrder(sum);
        setSumItem(sumi);
        setSumShipping(sums);
        setSumTotal(sumt)
        setDiscountShippingFee(sumds);
        setDiscountTransaction(sumdt)
        setSumDiscountMember(diskonmember);
    }

    function ExpeditionClick(index, WHCityID, ShippingCityID, ClickItems){
        setSelectedIndex(index)
        setSelectedWHCityID(WHCityID)
        setSelectedShippingCityID(ShippingCityID)
        let weight = 0;
        ClickItems.map((value, key)=>{
            weight+= value.ItemWeight * value.ItemQty;
        })
        setTotalWeight(weight);
        setIsOpen(true);
    }

    function changeIsOpen(value){
        setIsOpen(value);
    }

    function changeIsOpenReward(value){
        setIsOpenReward(value);
    }

    function changeIsOpenCoupon(value){
        setIsOpenCoupon(value);
    }

    function changeIsOpenBank(value){
        setIsOpenBank(value);
    }

    function changeIsOpenFAO(value){
        setIsOpenFAO(value);
    }

    function setExpedition(index, code, name, desc, price){
        let titems = items;
        titems[index].ExpeditionDetail= {
            ExpeditionCode: code,
            ExpeditionName: name,
            ExpeditionDescription: desc,
            ExpeditionFee: price
        }
        // console.log(titems[index])
        setItems(titems);
    }

    function setBank(code, name){
        setPaymentMethod({
            Code : code,
            Name: name
        })
    }

    function getMinumimOrder(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/checkout/minimumorder`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    function getMemberDiscount(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/member/memberdiscount`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    useEffect(async ()=>{
        setMemberStatus(jwt.decode(token).MemberStatus);
        let response = await getMinumimOrder();
        if(response.status == 200){
            setMinimumOrder(response.data)
        }else{
            toast.error(response.message);
        }
        if(jwt.decode(token).MemberStatus == "Active"){
            let response = await getMemberDiscount();
            if(response.status == 200){
                setDiscountMember(response.data.Value)
            }else{
                toast.error(response.message);
            }
        }
        if(history.location.state.items){
            (history.location.state.items).forEach(element => {
                if(element.PromoID != "" && element.PromoID != 0){
                    setIsPromo(true);
                }
            });
            setItems(history.location.state.items);
        }
    },[])

    useEffect(()=>{
        recalculate();
    })

    return (
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Checkout"/>
            <div style={{width:"100%", padding: "10px 0", marginBottom:"70px"}}>

                {
                    items.map((value, index)=>{
                        if(prevwh != value.WarehouseDetail.WarehouseID || prevshipmethod != value.ShippingMethod || prevshipdetail != value.ShippingDetail.ShippingDetailID){
                            prevwh = value.WarehouseDetail.WarehouseID;
                            prevshipmethod = value.ShippingMethod;
                            prevshipdetail = value.ShippingDetail.ShippingDetailID;
                            let filteritem = items.filter((value,index)=> value.WarehouseDetail.WarehouseID == prevwh && value.ShippingMethod == prevshipmethod && value.ShippingDetail.ShippingDetailID == prevshipdetail );
                            return (
                                <Cardcontainer
                                    items= {filteritem}
                                    key={index}
                                    uniquekey={index}
                                    warehousename={value.WarehouseDetail.WarehouseName}
                                    shippingmethod= {value.ShippingMethod}
                                    onClick={()=> ExpeditionClick(index, value.WarehouseDetail.WarehouseCityID, value.ShippingDetail.ShippingDetailCityOngkirID, filteritem)}
                                />
                            )
                        }
                    })
                }
                <div className="cart-card">
                    <div className="cart-footer">
                        <div className="cart-payment-label"  style={{flexGrow:1}}>
                            Note
                        </div>
                        <div className="cart-note" style={{minWidth:"200px"}}>
                            <input type="text" placeholder="Additional Note" style={{width:"100%"}} value={note} onChange={(e)=>setNote(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className="cart-card">
                    <div className="cart-footer">
                        <div className="cart-member-register">{
                            (memberStatus == "Join")?
                            (
                                (minimumOrder - sumitem) > 0 ?
                                (
                                    `Add Rp. ${numberWithCommas(minimumOrder - sumitem)} more to become a reseller`
                                ):
                                (
                                    `You reached the minimum amount to become a reseller`
                                )
                            ):
                            (<></>)
                        }</div>
                        <div></div>
                    </div>
                    <div className="cart-footer">
                        <div className="cart-payment-label"  style={{flexGrow:1}}>
                            Payment Method
                        </div>
                        <div className="cart-payment-name" onClick={()=> { setIsOpenBank(true) }}>
                            {
                                (!paymentMethod || paymentMethod.Code == "")?
                                (
                                    "Choose VA >"
                                ):
                                (
                                    paymentMethod.Name
                                )
                            }
                        </div>
                    </div>
                    <div className="cart-footer">
                        <div className="cart-payment-label"  style={{flexGrow:1}}>
                            Coupon
                        </div>
                        <div className="cart-payment-name" onClick={()=> { setIsOpenCoupon(true) }}>
                            {
                                (!coupons || coupons.length === 0)?
                                (
                                    "Select Coupon >"
                                ):
                                (
                                    `${coupons.length} Coupon(s) applied`
                                )
                            }
                        </div>
                    </div>
                    {
                        (!isPromo)?(
                            <div className="cart-footer">
                                <div className="cart-payment-label"  style={{flexGrow:1}}>
                                    Reward
                                </div>
                                <div className="cart-payment-name" onClick={()=> { setIsOpenReward(true) }}>
                                    {
                                        (!rewards || rewards.length === 0)?
                                        (
                                            "Select Reward >"
                                        ):
                                        (
                                            numberWithCommas(rewardAmount)
                                        )
                                    }
                                </div>
                            </div>
                        ):(
                            <></>
                        )
                    }
                    {
                        (memberStatus == "Join" && (minimumOrder - sumitem) <= 0)?(
                            <div className="cart-footer">
                                <div className="cart-payment-label"  style={{flexGrow:1}}>
                                    FAO
                                </div>
                                <div className="cart-payment-name" onClick={()=> { setIsOpenFAO(true) }}>
                                    {
                                        (!fao || !fao.Name)?
                                        (
                                            "Select FAO >"
                                        ):
                                        (
                                            fao.Name
                                        )
                                    }
                                </div>
                            </div>
                        ):(
                            <></>
                        )
                    }
                </div>
                <div className="cart-card">
                    <div className="cart-footer">
                        <div className="cart-payment-label"  style={{flexGrow:1}}>
                            Order Subtotal
                        </div>
                        <div>Rp. {numberWithCommas(sumitem)}</div>
                    </div>
                    {
                        (memberStatus == "Active")?(
                            <div className="cart-footer">
                                <div className="cart-payment-label"  style={{flexGrow:1}}>
                                    Member Discount
                                </div>
                                <div>- Rp. {numberWithCommas(sumdiscountmember)}</div>
                            </div>
                        ):
                        (
                            <></>
                        )
                    }
                    <div className="cart-footer">
                        <div className="cart-payment-label"  style={{flexGrow:1}}>
                            Shipping Fee
                        </div>
                        <div>Rp. {numberWithCommas(sumshipping)}</div>
                    </div>
                    <div className="cart-footer">
                        <div className="cart-payment-label"  style={{flexGrow:1}}>
                            Shipping Fee Discount
                        </div>
                        <div>- Rp. {numberWithCommas(sumdiscountshippingfee)}</div>
                    </div>
                    <div className="cart-footer">
                        <div className="cart-payment-label"  style={{flexGrow:1}}>
                            Promo Discount
                        </div>
                        <div>- Rp. {numberWithCommas(sumdiscounttransaction)}</div>
                    </div>
                    <div className="cart-footer">
                        <div className="cart-payment-label"  style={{flexGrow:1}}>
                            E-Reward
                        </div>
                        <div>- Rp. {numberWithCommas(rewardAmount)}</div>
                    </div>
                    <div className="cart-footer">
                        <div className="cart-payment-label"  style={{flexGrow:1}}>
                            Grand Total
                        </div>
                        <div><big>Rp. {numberWithCommas(sumtotal)}</big></div>
                    </div>
                </div>
            </div>
            <div className="cart-bottom">
                <div className="cart-footer">
                    <div className="" style={{flexGrow:1}}>
                        <div className="cart-footer-sub">SubTotal</div><div className="cart-footer-price">Rp {numberWithCommas(sumtotal)}</div>
                    </div>
                    <div >
                        <button className={`btn ${THEME_COLOR}`} onClick={submitHandler}>CHECKOUT</button>
                    </div>
                </div>
            </div>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpen}
                title="Choose Expedition"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpen(false)}
            >
                <Expedition
                    index = {selectedIndex}
                    changeIsOpen = {changeIsOpen}
                    setExpedition = {setExpedition}
                    whcityid = {selectedWHCityID}
                    shippingcityid = {selectedShippingCityID}
                    totalweight = {totalWeight}

                />
            </SlidingPane>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenBank}
                title="Choose Bank"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenBank(false)}
            >
                <Bank
                    changeIsOpenBank = {changeIsOpenBank}
                    setBank = {setBank}
                />
            </SlidingPane>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenReward}
                title="Choose Reward"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenReward(false)}
            >
                <Reward
                    rewards = {rewards}
                    changeIsOpenReward = {changeIsOpenReward}
                    setRewards = {setRewards}
                    setCoupons = {setCoupons}
                    setRewardAmount = {setRewardAmount}
                />
            </SlidingPane>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenCoupon}
                title="Choose Coupon"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenCoupon(false)}
            >
                <Coupon
                    sumitem = {sumitem}
                    coupons = {coupons}
                    changeIsOpenCoupon = {changeIsOpenCoupon}
                    setCoupons = {setCoupons}
                    setRewards = {setRewards}
                    setRewardAmount = {setRewardAmount}
                />
            </SlidingPane>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenFAO}
                title="Choose FAO"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenFAO(false)}
            >
                <FAO
                    changeIsOpenFAO = {changeIsOpenFAO}
                    setfao = {setfao}
                    fao = {fao}
                    items = {items}
                    setItems = {setItems}
                />
            </SlidingPane>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </React.StrictMode>
    )
}

export default Checkout;
